export interface ProblemDetailsError {
  code: string;
  message: string;
  propertyName?: string;
}

type Properties = {
  detail: string;
  errors: Array<ProblemDetailsError>;
  instance: string;
  status: number;
  title: string;
  traceId: string;
  type: string;
};

/**
 * Wrapper for handling ProblemDetails returned by API
 */
export class ProblemDetails {
  detail: string;
  errors: Array<ProblemDetailsError>;
  instance: string;

  constructor({ detail, errors, instance }: Properties) {
    this.detail = detail;
    this.errors = errors;
    this.instance = instance;
    Object.freeze(this);
  }

  /**
   * Get error message for code provided.
   * @param code
   * @returns found error message, or null if not found.
   */
  getCodeMessage(code: string): string | null {
    const result = this.errors.filter((error) => error.code === code);
    if (result.length === 0) {
      return null;
    }
    return result[0].message;
  }

  /**
   * Get error codes from problem details
   * @returns Array of error codes
   */
  getCodeNames(): Array<string> {
    return this.errors.map((error) => error.code);
  }
}
